import { useMutation } from '@tanstack/react-query';
import { customFetchV2 } from '../services/custom-fetch-v2';

type TicketType =
  | 'UKNOWN'
  | 'HELP_REQUEST'
  | 'FEATURE_REQUEST';

interface CreateSupportTicketRequest {
  fullName: string;
  email: string;
  description: string;
  ticketType: TicketType;
}

/**
 * API call to change a users password.
 */
const createSupportTicket =
  async (request: CreateSupportTicketRequest): Promise<void> => {
    const response = await customFetchV2('/api/v2/support-tickets', {
      method: 'POST',
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error(`Unable to create support ticket - HTTP response ${response.status}`);
    }
  };

const useCreateSupportTicketMutation = () => {
  return useMutation({
    mutationFn: createSupportTicket,
    onSuccess: () => {
      // TODO: Would make sense to invalidate related queries in here.. just need
      // to get hold of device ID and device profile ID
    },
  });
};

/** Exports */
export { useCreateSupportTicketMutation };

export type {
  CreateSupportTicketRequest,
};
